<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="15%" class="detailForm">
    <el-form-item :label="generateCustomizeString('name')" prop="username">
      <el-input v-model="form.username" :placeholder="generateCustomizeString('englishOnly')"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('email')" prop="email">
      <el-input v-model="form.email"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('phone')" prop="phone">
      <el-input v-model="form.phone"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('password')" prop="password">
      <el-input v-model="form.password" type="password"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">{{generateCustomizeString('add')}}</el-button>
      <el-button @click="onCancel">{{generateCustomizeString('cancel')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'AssistantDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        username: '',
        email: '',
        phone: '',
        password: ''
      },
      rules: {
        username: [
          {
            required: true,
            min: 4,
            max: 32,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            min: 6,
            max: 128,
            message: this.generateCustomizeString('between6To32Char'),
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            trigger: 'change'
          },
          {
            min: 8,
            max: 15,
            pattern: '^[0,1][1-9]',
            message: this.generateCustomizeString('between8To15Char'),
            trigger: 'change'
          }
        ],
        email: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur,change'
          }
        ]
      },
      createAssistantLoading: false
    }
  },
  methods: {
    generateCustomizeString,
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.fetchCreateAssistant(this.form)
        } else {
          this.$message.error('Input Data Error')
        }
      })
    },
    onCancel() {
      this.$router.push({ name: 'AssistantList' })
    },
    fetchCreateAssistant(params) {
      if (this.createAssistantLoading) return
      this.createAssistantLoading = true
      request({
        url: 'admin/assistant/create',
        method: 'post',
        data: params
      }).then(response => {
        console.log(response)
        if (response.status == 0) {
          // console.info('assistant create success', response)
          this.$refs.form.resetFields()
          this.$message.success('New Assistant Created Successfully')
          this.$store.dispatch('delCurrentViews', {
            view: this.$route,
            $router: this.$router
          })
          this.$router.replace({ name: 'AssistantList' })
        } else if (response.status === -1) {
          console.log('xxx')
          this.$message.warning(this.generateCustomizeString('useDifferentName'))
        }
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.createAssistantLoading = false
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .detailForm {
    padding: 50px 50px 0px 50px;
  }
</style>
